import React from 'react';
// template components
import StatModule from '@nmx/template/dist/componentLibrary/modules/StatModule';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <StatModule
    sectionId='term-life-insurance-intro'
    headingText={<>The right time in your life for <WidowBlock>term life.</WidowBlock></>}
    descriptionText={(
      <>
        A term life insurance policy from Northwestern Mutual will help make sure your mortgage gets paid, your kids are able to pay for college, or your family can cover everyday expenses should something happen to you. It&#39;s an affordable way to have the protection you want for a specific period of time.
      </>
    )}
    moduleName='stat-module'
    moduleVariation='A'
    ctaPrimary={{
      linkUrl: '/find-a-financial-advisor/',
      linkText: 'Get started',
      ariaLabel: 'Learn how to protect your assets with a financial advisor',
      linkId: 'term-life-insurance-product-intro-cta-button',
      children: '',
    }}
    ctaSecondary={{
      linkUrl: '',
      children: '',
    }}
    cardHeadingText={<>Less than <WidowBlock>&#36;1 a day</WidowBlock></>}
    cardHeadingTextAriaLabel='Less than one dollar a day'
    cardDescriptionText={(
      <>
        That&#39;s all it takes to make sure your family can be taken care of financially if the unexpected happens.<sup>1</sup>
      </>
    )}
  />
);
